import { AfterContentChecked, AfterContentInit, Directive, EventEmitter, Host, OnInit, Output } from '@angular/core';
import { KalFormFieldComponent } from '@kalidea/kaligraphi';
import { tap } from 'rxjs/operators';
import { SubscriptionManager } from 'src/app/_core/tools/subscription-manager';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'kal-form-field[valueChanges]',
    standalone: false
})
export class FormFieldChangesDirective<T = string> extends SubscriptionManager implements  AfterContentChecked {

    @Output() readonly valueChanges = new EventEmitter<T>();

    private internalState: 'dirty' | 'initialized' = 'dirty';

    constructor(
        @Host() private readonly formFieldComponent: KalFormFieldComponent,
    ) {
        super();
    }

    private init(): void {
        if (this.internalState === 'dirty') {
            if (this.formFieldComponent.formElement?.valueChanges) {
                this.watch$ = this.formFieldComponent.formElement.valueChanges.pipe(
                    tap(v => this.valueChanges.next(v))
                );
                this.internalState = 'initialized';
            }
        }
    }

    ngAfterContentChecked(): void {
        this.init();
    }


}
